{
  "toast": {
    "experimentCreated": "Experiment created",
    "winnerDeclared": "Winner declared",
    "marketingCampaignRegistered": "Marketing campaign registered",
    "enrichmentAppliedFromEmailDomain": "Enrichment applied from email domain",
    "formCreatedAndPublishedSuccessfully": "Form created and published successfully!",
    "formArchived": "Form archived",
    "formPublished": "Form published",
    "formUnpublished": "Form unpublished",
    "landingPageCreatedPublished": "Landing page created & published",
    "routingRuleSaved": "Routing rule saved",
    "leadScoringRuleSaved": "Lead scoring rule saved",
    "sourceCreated": "Source created",
    "duplicateCandidateResolved": "Duplicate candidate resolved"
  },
  "forms": {
    "createAcquisitionForm": "Create Acquisition Form",
    "publishImmediately": "Publish immediately",
    "visualFieldsSimulation": "Visual Fields Simulation",
    "remove": "Remove",
    "activeFormsList": "Active Forms List",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "testPublicView": "Test Public View",
    "embedConfigurations": "Embed Configurations",
    "close": "Close",
    "defaultFields": {
      "fullName": "Full name",
      "emailAddress": "Email address",
      "email": "Email",
      "phone": "Phone"
    },
    "captureTypes": {
      "general": "General",
      "contactUs": "Contact Us",
      "demoRequest": "Demo Request",
      "quoteRequest": "Quote Request",
      "supportRequest": "Support Request",
      "newsletterSignup": "Newsletter Signup"
    },
    "fieldTypes": {
      "text": "Text Input",
      "email": "Email Address",
      "phone": "Phone / Mobile",
      "date": "Date picker",
      "dropdown": "Dropdown Select",
      "checkbox": "Single Checkbox",
      "radio": "Radio Buttons",
      "multiselect": "Multi Select",
      "file": "File Upload"
    },
    "status": {
      "published": "Published",
      "draft": "Draft"
    },
    "submit": "Submit"
  },
  "breadcrumbs": {
    "leadGen": "Lead Gen",
    "campaigns": "Campaigns",
    "landingPages": "Landing Pages",
    "scoringRules": "Scoring Rules",
    "sources": "Sources",
    "consent": "Consent",
    "enrichment": "Enrichment",
    "leadRouting": "Lead Routing"
  },
  "errors": {
    "nameAndSlugRequired": "Name and slug required",
    "failedToLoadExperiments": "Failed to load experiments",
    "failedToLoadLandingPages": "Failed to load landing pages",
    "createFailed": "Create failed",
    "failedToDeclareWinner": "Failed to declare winner",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToCreateCampaign": "Failed to create campaign",
    "failedToLoadConsentLogs": "Failed to load consent logs",
    "crmLeadIdAndEmailRequired": "CRM lead ID and email required",
    "noEnrichmentForThisLeadYet": "No enrichment for this lead yet",
    "enrichmentFailed": "Enrichment failed",
    "failedToLoadForms": "Failed to load forms",
    "failedToCreateForm": "Failed to create form",
    "failedToUpdateForm": "Failed to update form",
    "failedToDeleteForm": "Failed to delete form",
    "failedToCreateLandingPage": "Failed to create landing page",
    "formNotFound": "Form not found",
    "submissionFailed": "Submission failed",
    "validationFailed": "Validation failed",
    "missingRequiredField": "Missing required field: {{field}}",
    "failedToLoadReports": "Failed to load reports",
    "failedToLoadRoutingRequirements": "Failed to load routing requirements",
    "failedToCreateRoutingRule": "Failed to create routing rule",
    "failedToLoadScoringRules": "Failed to load scoring rules",
    "failedToCreateScoringRule": "Failed to create scoring rule",
    "failedToLoadSources": "Failed to load sources",
    "failedToCreateSource": "Failed to create source",
    "failedToLoadVisitorProfiles": "Failed to load visitor profiles",
    "failedToLoadDashboard": "Failed to load dashboard",
    "failedToResolveDuplicateCandidate": "Failed to resolve duplicate candidate"
  },
  "reports": {
    "breadcrumb": "Reports",
    "summaryTitle": "Overview",
    "refresh": "Refresh",
    "refreshing": "Refreshing…",
    "retry": "Try again",
    "loading": "Loading report data…",
    "averageScoreLabel": "Average lead score: {{score}} pts",
    "gradeCount": "{{count}} leads",
    "summary": {
      "totalLeads": "Total leads",
      "conversionRate": "Lead conversion rate",
      "convertedCount": "{{count}} converted",
      "avgLeadScore": "Average lead score",
      "overallRoi": "Overall ROI",
      "spendRevenue": "Spend {{spend}} · Revenue {{revenue}}",
      "formSubmissions": "Form submissions",
      "activeCampaigns": "Active campaigns",
      "totalSpend": "Total campaign spend"
    },
    "columns": {
      "source": "Source",
      "leads": "Leads",
      "converted": "Converted",
      "conversionRate": "Conversion rate",
      "share": "Share",
      "campaign": "Campaign",
      "channel": "Channel",
      "budget": "Budget",
      "cost": "Cost",
      "utmCampaign": "UTM campaign",
      "status": "Status",
      "eventType": "Event type",
      "count": "Count",
      "utmSource": "UTM source",
      "model": "Model",
      "attributedLeads": "Attributed leads",
      "leadCost": "Cost per lead",
      "revenue": "Revenue attributed",
      "roi": "ROI"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "eventTypes": {
      "FORM_SUBMISSION": "Form submission",
      "PAGE_VIEW": "Page view",
      "CLICK": "Click",
      "CONVERSION": "Conversion",
      "LEAD_CREATED": "Lead created"
    },
    "empty": {
      "leadSource": "No lead source data yet",
      "leadSourceHint": "Capture leads via forms or imports to see source breakdown.",
      "conversion": "No conversion events yet",
      "conversionHint": "Visitor and form activity will appear here as events are tracked.",
      "campaign": "No campaigns configured",
      "campaignHint": "Add campaigns to track spend, UTM tags, and ROI.",
      "attribution": "No attribution data yet",
      "attributionHint": "Multi-touch attribution appears when leads have UTM touchpoints.",
      "roi": "No ROI data yet",
      "roiHint": "Set campaign cost and revenue attribution to calculate ROI."
    }
  },
  "duplicates": {
    "title": "Duplicate Review",
    "description": "Review duplicate lead candidates created by configurable duplicate detection rules.",
    "breadcrumbs": {
      "leadGen": "Lead Gen",
      "duplicates": "Duplicates"
    },
    "columns": {
      "candidate": "Candidate #",
      "submission": "Submission",
      "incomingLead": "Incoming Lead",
      "matchedLead": "Matched Lead",
      "matchedFields": "Matched Fields",
      "suggestedAction": "Suggested Action",
      "actions": "Actions"
    },
    "actions": {
      "updateExisting": "Update existing",
      "ignore": "Ignore",
      "merge": "Merge"
    },
    "empty": {
      "title": "No duplicate candidates",
      "description": "New duplicate candidates will appear here for review."
    }
  },
  "campaigns": {
    "sections": {
      "registerAcquisitionCampaign": "Register Acquisition Campaign",
      "attributionsOverview": "Attributions overview"
    },
    "attributionModels": {
      "first": "First Touch (Full credit to initial click)",
      "last": "Last Touch (Full credit to conversion page)",
      "multi": "Multi-Touch (Weighted split across touchpoints)"
    },
    "channelLabel": "Channel: {{channel}}",
    "roiLabel": "ROI: {{roi}}",
    "metrics": {
      "budget": "Budget",
      "cost": "Cost",
      "revenue": "Revenue"
    }
  },
  "pages": {
    "aBLandingTests": "A/B landing tests",
    "trafficSplitExperimentsAcrossLandingPage": "Traffic-split experiments across landing page variants",
    "marketingCampaignsRoi": "Marketing Campaigns & ROI",
    "linkAdvertisingCostsUtmParametersAnd": "Link advertising costs, UTM parameters, and multi-touch revenue attribution modeling.",
    "gdprConsentTracking": "GDPR & Consent Tracking",
    "configurePrivacyBannersTrackPolicyConsent": "Configure privacy banners, track policy consent versions, and audit user acceptance logs.",
    "leadGenDashboard": "Dashboard",
    "additionalMetrics": "Additional metrics",
    "totalVisitors": "Total visitors",
    "conversions": "Conversions",
    "avgLeadScore": "Avg. lead score",
    "inboundAcquisitionFunnel": "Inbound acquisition funnel",
    "leadScoreDistribution": "Lead score distribution",
    "campaignRoi": "Campaign ROI",
    "visitorTrackingFormsScoringAndCrm": "Visitor tracking, forms, scoring, and CRM conversion in your scope",
    "topLeadSources": "Top lead sources",
    "noLeadSourceData": "No lead source data yet",
    "noFunnelData": "No funnel activity for this period",
    "noScoreData": "No scored leads yet",
    "noCampaignData": "No campaigns yet",
    "createSource": "Add lead source",
    "createCampaign": "Create campaign",
    "leadsCount": "{{count}} leads",
    "shareLabel": "Share: {{share}}",
    "scorePoints": "{{score}} pts",
    "visitorsTrend": "CVR {{rate}}% · {{submissions}} submissions",
    "roiPercent": "{{value}}% ROI",
    "quickLinkForms": "Manage forms",
    "quickLinkCampaigns": "View campaigns",
    "quickLinkReports": "Open reports",
    "leadEnrichment": "Lead enrichment",
    "domainInferenceAndFirmographicHintsRuns": "Domain inference and firmographic hints — runs automatically on form submit; manual refresh here",
    "acquisitionLeadForms": "Acquisition Lead Forms",
    "visualFormBuilderAndSecureEmbedding": "Visual Form Builder and secure embedding configurations.",
    "landingPageBuilder": "Landing Page Builder",
    "launchHighConvertingLandingPagesWith": "Launch high-converting landing pages with native A/B testing and custom domain support.",
    "leadGenReports": "Lead Gen Reports",
    "leadSourceReport": "Lead Source Report",
    "campaignReport": "Campaign Report",
    "conversionReport": "Conversion Report",
    "scoringReport": "Scoring Report",
    "attributionReport": "Attribution Report",
    "roiReport": "ROI Report",
    "leadSourceCampaignConversionScoringAttribution": "Lead source, campaign, conversion, scoring, attribution, and ROI analytics.",
    "leadRoutingTerritories": "Lead Routing & Territories",
    "configureAutomatedAssignmentCriteriaByCountry": "Configure automated assignment criteria by country, region, state, or product, with integrated round-robin distribution.",
    "leadScoringGrading": "Lead Scoring & Grading",
    "establishScoringThresholdsAndAssignQuality": "Establish scoring thresholds and assign quality grades (A+, A, B, C, D) based on visitor events and profiles.",
    "leadSources": "Lead Sources",
    "acquisitionChannelCatalogWebsiteAdsSocial": "Acquisition channel catalog — website, ads, social, partner portal, and API imports.",
    "visitorSessionTracking": "Visitor Session Tracking",
    "monitorAnonymousVisitorPathsReferrersAnd": "Monitor anonymous visitor paths, referrers, and cookie IDs prior to lead conversion.",
    "leadAdWebhooks": "Lead ad webhooks",
    "facebookAndGoogleLeadAdsPost": "Facebook and Google Lead Ads POST into LeadIntakeService — same path as form submissions"
  },
  "landingPages": {
    "sections": {
      "createLandingPage": "Create Landing Page",
      "activeLandingPages": "Active Landing Pages"
    },
    "variants": {
      "a": "Variant A (Default Layout)",
      "b": "Variant B (Interactive Form Side)",
      "c": "Variant C (Minimalistic Text Only)"
    },
    "templates": {
      "demo": "Interactive Product Demo Signup",
      "newsletter": "Newsletter Subscription Panel",
      "quote": "Finance & Quotation Estimator"
    },
    "versionLabel": "Version {{version}}",
    "variantLabel": "Variant {{variant}}",
    "metrics": {
      "views": "Views",
      "conversions": "Conversions"
    }
  },
  "scoring": {
    "sections": {
      "defineLeadScoringRule": "Define Lead Scoring Rule",
      "gradingThresholdMatrix": "Grading Threshold Matrix",
      "configuredRules": "Configured Rules"
    },
    "triggerEvents": {
      "formSubmission": "On Form Submission",
      "pageView": "On Landing Page View",
      "emailOpen": "On Campaign Email Opened",
      "download": "On Whitepaper/Asset Download",
      "leadCreated": "On Inbound Lead Intake"
    },
    "pointsRange": "{{range}} points",
    "ruleDeltaLabel": "Delta: {{delta}} on {{eventType}}",
    "status": {
      "active": "Active"
    },
    "empty": {
      "noGradeConfig": "No grade config from server — check LEAD_GEN_SCORING feature."
    }
  },
  "empty": {
    "noExperimentsYet": "No experiments yet"
  },
  "publicSubmit": {
    "thankYou": "Thank you",
    "requestReceived": "We received your request and will be in touch shortly.",
    "contactUs": "Contact us",
    "gdprConsent": "I consent to my data being processed (GDPR)"
  },
  "dialogs": {
    "declareWinner": "Declare winner"
  },
  "labels": {
    "experimentName": "Experiment name",
    "slug": "Slug",
    "variantPageIdsComma": "Variant page IDs (comma)",
    "trafficWeights": "Traffic weights",
    "campaignName": "Campaign Name",
    "adPlatformChannel": "Ad Platform / Channel",
    "allocatedBudgetInr": "Allocated Budget (INR)",
    "actualCostInr": "Actual Cost (INR)",
    "revenueAttributedInr": "Revenue Attributed (INR)",
    "attributionModel": "Attribution Model",
    "eGQ2EnterpriseCloudPromo": "e.g. Q2 Enterprise Cloud Promo",
    "eGLinkedinAds": "e.g. LinkedIn Ads",
    "bannerTextCookieConsent": "Banner Text (Cookie Consent)",
    "privacyStatementForms": "Privacy Statement (Forms)",
    "crmLeadId": "CRM lead ID",
    "emailForDomainEnrich": "Email (for domain enrich)",
    "formName": "Form Name",
    "description": "Description",
    "captureType": "Capture Type",
    "fieldLabel": "Field Label",
    "fieldType": "Field Type",
    "optionsCommaSeparated": "Options (Comma separated)",
    "eGInboundDemoRequest": "e.g. Inbound Demo Request",
    "optionalInternalDescription": "Optional internal description...",
    "eGOrganizationName": "e.g. Organization Name",
    "eGSmallMediumEnterprise": "e.g. Small, Medium, Enterprise",
    "pageTitle": "Page Title",
    "urlSlug": "URL Slug",
    "customDomain": "Custom Domain",
    "aBVariant": "A/B Variant",
    "landingPageTemplate": "Landing Page Template",
    "eGFreeEnterpriseAuditTrial": "e.g. Free Enterprise Audit Trial",
    "eGEnterpriseAudit": "e.g. enterprise-audit",
    "eGPromoMycompanyCom": "e.g. promo.mycompany.com",
    "ruleName": "Rule Name",
    "priorityOrder": "Priority Order",
    "assignToEmployee": "Assign to employee",
    "teamQueueCodeOptional": "Team / Queue Code (Optional)",
    "crmTerritoryOptional": "CRM territory (optional)",
    "eGIndiaRegionRouting": "e.g. India Region Routing",
    "leaveBlankForRoundRobinQueue": "Leave blank for round-robin queue",
    "eGInSalesTeam": "e.g. IN_SALES_TEAM",
    "none": "— None —",
    "scoreDeltaPoints": "Score Delta (Points)",
    "triggerEvent": "Trigger Event",
    "eGEnterpriseIndustryMatch": "e.g. Enterprise Industry Match",
    "eG15Or10": "e.g. 15 or -10",
    "code": "Code",
    "name": "Name",
    "sourceType": "Source type",
    "partnerXReferrals": "Partner X Referrals",
    "winnerLandingPageId": "Winner landing page ID",
    "webhookSecret": "Webhook secret",
    "optionalEnforcedInSecurityPhase": "Optional, enforced in security phase"
  },
  "sources": {
    "configuredSources": "Configured Sources",
    "addCustomSource": "Add Custom Source"
  },
  "formActions": {
    "saveRoutingPolicy": "Save Routing Policy",
    "saveCampaign": "Save Campaign",
    "addSource": "Add Source",
    "saveScoringRule": "Save Scoring Rule",
    "addField": "Add Field",
    "saveAndPublishForm": "Save & Publish Form"
  },
  "listActions": {
    "createExperiment": "Create experiment",
    "getEmbedCode": "Get Embed Code",
    "publishLandingPage": "Publish Landing Page"
  }
}
